import { useContext } from 'react'
import { CommonUtils } from '@ocean/utils'
import { LayoutProps, CardLayoutSegmentProps } from 'layouts/types'
import withLayout from 'layouts/withLayout'
import { CardContainer } from 'components/cards/common'
import { UICardType } from 'components/cards/common/types'
import { GridCarouselContext } from 'components/common/GridCarousel'
import {
  Root,
  Wrapper,
  Preview,
  Title,
  Label,
  Info,
  Footer,
  Status,
  Progress,
} from './CardLayout.styled'

export type CardLayoutSegments = 'preview' | 'title' | 'label' | 'info' | 'status' | 'progress'
type InternalLayoutProps = LayoutProps<CardLayoutSegments>

export const CardSegment: React.FC<CardLayoutSegmentProps> = ({ children }) => <>{children}</>

const CardLayout = ({ segments, variant, dataTest }: InternalLayoutProps) => {
  const isCardInsideCarousel = useContext(GridCarouselContext)
  const { preview, title, label, info, status, progress } = segments || {}

  function renderCardLayout() {
    return (
      <CardContainer>
        <Preview>{preview}</Preview>
        <Title>{title}</Title>
        <Label>{label}</Label>
        <Info>{info}</Info>
        <Footer>
          <Status>{status}</Status>
          <Progress>{progress}</Progress>
        </Footer>
      </CardContainer>
    )
  }

  function renderGroupLayout() {
    return (
      <CardContainer boxShadow>
        <Title>{title}</Title>
        <Label>{label}</Label>
        <Footer>
          <Status>{status}</Status>
          <Progress>{progress}</Progress>
        </Footer>
      </CardContainer>
    )
  }

  function renderPreviewGroupLayout() {
    return (
      <CardContainer boxShadow>
        <Preview>{preview}</Preview>
        <Title>{title}</Title>
        <Label>{label}</Label>
        <Footer>
          <Status>{status}</Status>
          <Progress>{progress}</Progress>
        </Footer>
      </CardContainer>
    )
  }

  function renderCategoryLayout() {
    return (
      <CardContainer boxShadow>
        <Title>{title}</Title>
        <Label>{label}</Label>
      </CardContainer>
    )
  }

  function renderEventLayout() {
    return (
      <CardContainer>
        <Preview>{preview}</Preview>
        <Title>{title}</Title>
        <Label>{label}</Label>
        <Info>{info}</Info>
        <Footer />
      </CardContainer>
    )
  }

  function renderEventsScheduleLayout() {
    return (
      <CardContainer boxShadow>
        <Preview>{preview}</Preview>
        <Title>{title}</Title>
        <Label>{label}</Label>
      </CardContainer>
    )
  }

  function getCardLayout(): React.ReactElement {
    switch (variant) {
      case UICardType.Group:
        return renderGroupLayout()
      case UICardType.PreviewGroup:
        return renderPreviewGroupLayout()
      case UICardType.Event:
        return renderEventLayout()
      case UICardType.EventsSchedule:
        return renderEventsScheduleLayout()
      case UICardType.Category:
      case UICardType.EventsCategory:
        return renderCategoryLayout()
      case UICardType.Proficiency:
      case UICardType.Activity:
      default:
        return renderCardLayout()
    }
  }

  return (
    <Root
      responsiveOnHover={!isCardInsideCarousel}
      variant={variant}
      data-test={CommonUtils.createDataTest('Card', dataTest)}
    >
      <Wrapper>{getCardLayout()}</Wrapper>
    </Root>
  )
}

export default withLayout(CardLayout)
